import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Filter from "./components/Filter";
import {useEffect, useState} from "react";
import {subMonths} from "date-fns";
import eventsApi from "../../api/eventsApi/eventsApi";
import Map from "./components/Map";
import Summary from "./components/Summary";
import {useDispatch} from "react-redux";
import {saveEventTypes} from "../../redux/actions/appActions";
import {useSelector} from "../../redux/store";

const defaultFiltreler = {
	dateStart: subMonths(new Date(), 1),
	dateEnd: new Date(),
}

const Home = () => {
	const [filters, setFilters] = useState<any>(defaultFiltreler)
	const [events, setEvents] = useState<any>([])
	const [pins, setPins] = useState<any>([])
	const [isLoading, setIsLoading] = useState(true)
	const dispatch = useDispatch()
	
	// Responsive breakpoint
	const isTabletScreen = useMediaQuery('(min-width:600px) and (max-width:1199px)');
	
	// Redux'tan auth durumunu al
	const accessToken = useSelector((state) => state.auth.accessToken);
	const userId = useSelector((state) => state.auth.id);
	const isAuthenticated = !!accessToken && !!userId;

	// Sadece kullanıcı authenticate olduğunda initial data'yı fetch et
	useEffect(() => {
		if (!isAuthenticated) {
			console.log('User not authenticated, skipping API calls...');
			setIsLoading(false);
			return;
		}
		
		// Add small delay to ensure authorization header is set
		const timer = setTimeout(() => {
			// Fetch pins
			eventsApi.getPins().then((res: any) => {
				setPins(res?.items ?? [])
			}).catch((error) => {
				console.error('Error fetching pins:', error);
			});
			
			// Fetch event types and save to Redux store
			eventsApi.getEventTypes().then((response: any) => {
				// Ensure eventTypes is an array
				const eventTypes = Array.isArray(response) ? response : 
					(response?.items ? response.items : []);
				
				// Convert to expected format if needed
				const formattedEventTypes = eventTypes.map((type: any) => ({
					label: type.name || type.label || '',
					value: type.id || type.value || ''
				}));
				
				dispatch(saveEventTypes(formattedEventTypes))
			}).catch((error) => {
				console.error('Error fetching event types:', error);
			});
		}, 100); // 100ms delay to ensure auth setup is complete

		return () => clearTimeout(timer);
	}, [isAuthenticated, dispatch])

	// Filters değiştiğinde events'i fetch et (sadece authenticated kullanıcılar için)
	useEffect(() => {
		if (!isAuthenticated) {
			setIsLoading(false);
			return;
		}

		setIsLoading(true)
		if (filters?.dateStart && filters?.dateEnd) {
			// Add small delay to ensure authorization header is set
			const timer = setTimeout(() => {
				// Şehir seçili değilse getEventsCounts, seçili ise getEvents kullan
				const apiCall = filters.city ? eventsApi.getEvents : eventsApi.getEventsCounts;
				
				apiCall(filters)
					.then(res => {
						setEvents(res);
					})
					.catch((error) => {
						console.error('Error fetching events:', error);
						setEvents([]);
					})
					.finally(() => {
						setIsLoading(false)
					});
			}, 50); // 50ms delay for filter-based calls

			return () => clearTimeout(timer);
		} else {
			setIsLoading(false);
		}
	}, [filters, isAuthenticated])

	return <Box 
		width={"100%"} 
		sx={{ 
			position: 'relative', 
			zIndex: 0,
			px: isTabletScreen ? 0.5 : 0, // Tablet'te minimal padding
			maxWidth: '100vw', // Viewport genişliğini aşmasın
			overflow: 'hidden' // Yatay scroll'u engelle
		}}
	>
		<Grid 
			container 
			spacing={isTabletScreen ? 0.5 : 2} 
			sx={{ 
				position: 'relative',
				width: '100%',
				margin: 0, // Grid'in default margin'ini kaldır
				'& > .MuiGrid-item': {
					paddingLeft: isTabletScreen ? '4px' : undefined,
					paddingTop: isTabletScreen ? '4px' : undefined
				}
			}}
		>
			<Grid item xs={12}>
				<Filter filters={filters} setFilters={setFilters} defaults={defaultFiltreler}/>
			</Grid>
			<Grid item xs={12} sm={12} md={9} sx={{ position: 'relative', zIndex: 1 }}>
				<Map
					setPins={setPins}
					pins={pins}
					events={events}
					filters={filters}
					setFilters={setFilters}
					isLoading={isLoading}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={3}>
				<Summary
					eventTypeCounts={events.eventTypeCounts}
					districtEventCounts={events.districtEventCounts}
					startDate={filters.dateStart}
					endDate={filters.dateEnd}
					filters={filters}
					isLoading={isLoading}
				/>
			</Grid>
		</Grid>
	</Box>
}
export default Home;